import faBook from "icons/solid/book.svg";
import faHeadphones from "icons/solid/headphones.svg";
import faTablet from "icons/solid/tablet.svg";

import faBookRegular from "icons/regular/book.svg";
import faHeadphonesRegular from "icons/regular/headphones.svg";
import faTabletRegular from "icons/regular/tablet.svg";

export default interface ReadingFormatType {
  id: ReadingFormatIDType;
  format: string;
  icon?: any;
  iconRegular?: any;
}

export type ReadingFormatIDType = 1 | 2 | 3 | 4;

export const textReadingFormat: ReadingFormatType = {
  id: 1,
  format: "Physical Book",
  icon: faBook,
  iconRegular: faBookRegular,
};
export const audioReadingFormat: ReadingFormatType = {
  id: 2,
  format: "Audiobook",
  icon: faHeadphones,
  iconRegular: faHeadphonesRegular,
};
export const ebookReadingFormat: ReadingFormatType = {
  id: 4,
  format: "E-Book",
  icon: faTablet,
  iconRegular: faTabletRegular,
};

export const ReadingFormats: ReadingFormatType[] = [
  textReadingFormat,
  audioReadingFormat,
  ebookReadingFormat,
];

export const ReadingFormatByFormat = {
  book: 1,
  audio: 2,
  ebook: 4,
};

export const ReadingFormatByID = {
  1: textReadingFormat,
  2: audioReadingFormat,
  4: ebookReadingFormat,
};
